const ListHeader = ({ Icon, title }: any) => (
  <div className="flex gap-3 items-center bg-primary-800 educator-dashboard-box-shadow-cards rounded-lg p-4">
    <Icon className="min-w-[30px] h-[30px] fill-primary-600" />
    <div className="text-white font-medum text-base line-clamp-3">{title}</div>
  </div>
);

export default ListHeader;
